// Shared room_restriction -> display helpers used across the Service app,
// Driftsdashboard, and anywhere else a room's gender restriction is shown.

const ROOM_RESTRICTION_COLORS = {
  male: "#1d4ed8",
  female: "#db2777",
};

export const getRoomRestrictionType = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();

  if (normalized === "male" || normalized === "female") {
    return normalized;
  }

  return null;
};

// Extracts a "(male)"/"(female)" suffix from a label (e.g. a room type name),
// for callers that only have a combined display string rather than a raw field.
export const getRoomRestrictionTypeFromLabel = (label) => {
  const match = String(label || "")
    .toLowerCase()
    .match(/\((male|female)\)\s*$/);
  return match ? match[1] : null;
};

// Strips a "(male)"/"(female)" suffix from a label; pair with a colour to
// convey the restriction visually instead of via text.
export const stripRoomRestrictionSuffix = (label) =>
  String(label || "")
    .replace(/\s*\((male|female)\)\s*$/i, "")
    .trim();

// Returns the colour for a room_restriction value: blue for male, pink for
// female, and the given fallback (default near-black "text.primary") for none.
export const getRoomRestrictionColor = (value, fallback = "text.primary") => {
  const type = getRoomRestrictionType(value);
  return type ? ROOM_RESTRICTION_COLORS[type] : fallback;
};
